/* tslint:disable:quotemark whitespace max-line-length */
import { Injectable } from '@angular/core';
import { AcceptDeposit, Configuration, DefaultServiceInterface, XmlExport } from '@gcv/services';
import { HttpHeaders } from '@angular/common/http';
import { interval, Observable, of } from 'rxjs';
import { throttle } from 'rxjs/operators';
import {
  BankAggregate,
  DispensaryAggregate,
  FincenAggregate,
  FincenDepositAggregate,
  SalesAggregate,
} from './mock.data';
import { DepositService } from './deposit.service';
import { BankService } from './bank.service';
import { DispensaryService } from './dispensary.service';
import { FincenService } from './fincen.service';
import { NotificationsService } from './notifications.service';
import { UserService } from './user.service';
import { SalesFileService } from './salesFile.service';
import { SalesService } from './sales.service';
import { VendorService } from './vendor.service';

@Injectable({
  providedIn: 'root',
})
export class MockDefaultService implements DefaultServiceInterface {
  defaultHeaders: HttpHeaders;
  configuration: Configuration;

  constructor(
    private depositService: DepositService,
    private bankService: BankService,
    private dispensaryService: DispensaryService,
    private fincenService: FincenService,
    private userService: UserService,
    private notificationService: NotificationsService,
    private salesFileService: SalesFileService,
    private salesService: SalesService,
    private vendorService: VendorService
  ) {}

  notificationsIdDelete(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  dispensariesIdTransportVendorVendorTypeVendorIdPut(
    vendorId: string,
    vendorType: string,
    id: string,
    transportVendor2: any,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const vendor = this.vendorService.putVendorById(transportVendor2);
    const dispensary = this.dispensaryService.getDispensaryById(id);
    if (vendorType === 'user') {
      dispensary.methodOfTransportation.user = dispensary.methodOfTransportation.user.map(oldVendor => {
        if (vendor.id === oldVendor.id) {
          return {
            ...oldVendor,
            ...{
              name: vendor.name,
              active: true,
              favorite: false,
              id: vendor.id,
            },
          };
        } else {
          return oldVendor;
        }
      });
    } else {
      dispensary.methodOfTransportation.vendor = [
        {
          name: vendor.name,
          active: true,
          favorite: false,
          id: vendor.id,
        },
      ];
    }
    this.dispensaryService.putDispensary(dispensary);
    return of(dispensary).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdTransportVendorPost(
    id: string,
    transportVendor1: import('@gcv/services').TransportVendor1,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const vendor = this.vendorService.createVendor(transportVendor1);
    const dispensary = this.dispensaryService.getDispensaryById(id);
    dispensary.methodOfTransportation.vendor.push({
      active: true,
      favorite: false,
      id: vendor.id,
      name: vendor.name,
    });
    this.dispensaryService.putDispensary(dispensary);
    return of(dispensary).pipe(throttle(() => interval(2000)));
  }

  banksIdTransportVendorPost(
    id: string,
    transportVendor0: import('@gcv/services').TransportVendor0,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const bank = this.bankService.getBankById(id);
    const dispensary = this.dispensaryService.getDispensaryById('123456');
    this.dispensaryService.putDispensary({ ...dispensary, name: 'POSTED VENDOR' });
    return of(this.bankService.updateBank({ ...bank, orgName: 'POSTBANKVENDOR' })).pipe(throttle(() => interval(3000)));
  }

  banksIdTransportVendorVendorIdPut(
    vendorId: string,
    id: string,
    transportVendor4: import('@gcv/services').TransportVendor4,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const bank = this.bankService.getBankById(id);
    return of(this.bankService.updateBank({ ...bank, orgName: 'PUTBANKVENDOR' })).pipe(throttle(() => interval(3000)));
  }

  banksIdDispensariesDispensaryIdPut(dispensaryId: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  banksIdTransportVendorVendorIdDelete(vendorId: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    const bank = this.bankService.getBankById(id);
    return of(
      this.bankService.updateBank({
        ...bank,
        orgName: 'BANKVENDORDELETE',
      })
    ).pipe(throttle(() => interval(3000)));
  }

  banksIdTransportVendorVendorIdDispensariesDispensaryIdDelete(
    dispensaryId: string,
    vendorId: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const dispensary = this.dispensaryService.getDispensaryById('123456');
    this.dispensaryService.putDispensary({ ...dispensary, name: 'DELETE VENDOR' });
    const bank = this.bankService.getBankById(id);
    return of(
      this.bankService.updateBank({
        ...bank,
        orgName: 'BANKVENDORDISPIDDELETE',
      })
    ).pipe(throttle(() => interval(3000)));
  }

  banksIdTransportVendorVendorIdDispensariesDispensaryIdPut(
    dispensaryId: string,
    vendorId: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const dispensary = this.dispensaryService.getDispensaryById('123456');
    this.dispensaryService.putDispensary({ ...dispensary, name: 'PUT VENDOR' });
    const bank = this.bankService.getBankById(id);
    return of(
      this.bankService.updateBank({
        ...bank,
        orgName: 'DISPENSARYVENDORBANKPUT',
      })
    ).pipe(throttle(() => interval(3000)));
  }

  banksIdTransportVendorVendorIdDispensariesPut(
    vendorId: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const bank = this.bankService.getBankById(id);
    return of(
      this.bankService.updateBank({
        ...bank,
        orgName: 'VENDORPUTALLBANK',
      })
    ).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdTransportVendorVendorTypeVendorIdDelete(
    vendorId: string,
    vendorType: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  dispensariesIdTransportVendorVendorTypeVendorIdFavoritePut(
    vendorId: string,
    vendorType: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    const dispensary = this.dispensaryService.getDispensaryById(id);
    return of(
      this.dispensaryService.putDispensary({
        ...dispensary,
        name: 'FAVORITEDISPBANK',
      })
    ).pipe(throttle(() => interval(3000)));
  }

  organizationsIdGroupsGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  public gcvUserIdVerificationPut(id: string, observe?: 'body', reportProgress?: boolean): Observable<any> {
    return of(this.userService.manuallyVerifyUser(id)).pipe(throttle(() => interval(3000)));
  }

  organizationsIdGroupsGroupIdUsersUserIdDelete(
    userId: string,
    id: string,
    groupId: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  organizationsIdGroupsGroupIdUsersUserIdPut(
    userId: string,
    id: string,
    groupId: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  organizationsIdGroupsPut(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  transportVendorIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.vendorService.getVendorById(id)).pipe(throttle(() => interval(3000)));
  }

  usersIdDocumentsPut(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  organizationsIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  organizationsIdPut(id: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  organizationsPost(organization: import('@gcv/services').Organization, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  usersIdKbaGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.userService.getKba(id)).pipe(throttle(() => interval(3000)));
  }

  usersIdVerifyPost(id: string, answers: any, extraHttpRequestParams?: any): Observable<{}> {
    const user = this.userService.getUserById('123456');
    user.identityVerified = false;
    return of(this.userService.putUserById(user)).pipe(throttle(() => interval(3000)));
  }

  organizationsIdUsersGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    this.userService.createUser({ id: '1234123' });
    return of([this.userService.getUserById('1234123'), this.userService.getUserById('123456')]).pipe(
      throttle(() => interval(3000))
    );
  }

  groupsOrgIdGet(orgId: string, extraHttpRequestParams?: any): Observable<{}> {
    throw new Error('Method not implemented.');
  }

  groupsOrgIdPut(orgId: string, groups: import('@gcv/services').Groups, extraHttpRequestParams?: any): Observable<{}> {
    if (this.bankService.bank[orgId]) {
      return of(this.bankService.putGroupsById(orgId, groups)).pipe(throttle(() => interval(3000)));
    } else {
      return of(this.dispensaryService.updateGroups(orgId, groups)).pipe(throttle(() => interval(3000)));
    }
  }

  aggregatesCompanyIdTypeGet(type: string, companyId: string, extraHttpRequestParams?: any): Observable<{}> {
    const res = {
      company_id: '1234567',
      data: null,
    };
    switch (type) {
      case 'bank':
        res.company_id = companyId;
        res.data = BankAggregate;
        break;
      case 'fincenDeposits':
        res.company_id = companyId;
        res.data = FincenDepositAggregate;
        break;
      case 'fincen':
        res.company_id = companyId;
        res.data = [FincenAggregate, FincenAggregate];
        break;
      case 'sales':
        res.company_id = companyId;
        res.data = SalesAggregate;
        break;
      case 'dispensary':
        res.company_id = companyId;
        res.data = DispensaryAggregate;
        break;
    }
    return of(res).pipe(throttle(() => interval(2000)));
  }

  authTestGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  usersIdZendeskJwtGet(userId: string): Observable<{}> {
    return of({});
  }

  authTestPost(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  banksGet(extraHttpRequestParams?: any): Observable<{}> {
    return of(Object.values(this.bankService.bank)).pipe(throttle(() => interval(3000)));
  }

  banksIdDelete(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  banksIdDispensariesDispensaryIdDepositsDepositIdAcceptPost(
    depositId: string,
    dispensaryId: string,
    id: string,
    acceptDeposit: AcceptDeposit
  ) {
    return of(this.depositService.approveDeposit(depositId)).pipe(throttle(() => interval(3000)));
  }

  banksIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.bankService.getBankById(id)).pipe(throttle(() => interval(2000)));
  }

  banksIdPut(id: string, data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.bankService.updateBank(data)).pipe(throttle(() => interval(2000)));
  }

  banksPost(data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.bankService.createBank(data)).pipe(throttle(() => interval(3000)));
  }

  confirmUserGet(
    userName: string,
    clientId: string,
    redirectUrl: string,
    confirmCode: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesGet(extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.loadAllDispensaries()).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdDelete(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  dispensariesIdDepositsDepositIdSalesGet(depositId: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.salesService.getSales(depositId, id)).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdDepositsDepositIdSalesPaginatedGet(
    depositId: string,
    id: string,
    key?: string,
    limit?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesIdDepositsGet(
    id: string,
    endDate?: string,
    startDate?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return of(this.depositService.getAllDeposits()).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdDepositsNewGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.depositService.fetchNewDeposit()).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdDepositsPost(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.depositService.createDeposit()).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdDiligenceBankBankIdPost(bankId: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.bankdd(id)).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdDiligenceGcvPost(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.gcvdd(id)).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.getDispensaryById(id)).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdPut(id: string, data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.putDispensary(data)).pipe(throttle(() => interval(2000)));
  }

  dispensariesIdSalesGet(
    id: string,
    endDate?: string,
    startDate?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesIdSalesPaginatedGet(
    endDate: string,
    startDate: string,
    id: string,
    status?: string,
    key?: string,
    limit?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return of(this.salesService.getSales('12345', '12345')).pipe(throttle(() => interval(3000)));
  }

  dispensariesIdSalesfilesGet(
    id: string,
    endDate?: string,
    startDate?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesIdSalesfilesPost(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  dispensariesIdSalesfilesS3DateUploadedGet(
    s3DateUploaded: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesIdSalesfilesS3DateUploadedSalesGet(
    s3DateUploaded: string,
    id: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesIdSalesfilesS3DateUploadedSalesPaginatedGet(
    s3DateUploaded: string,
    id: string,
    key?: string,
    limit?: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return;
  }

  dispensariesPost(data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.dispensaryService.createDispensary(data)).pipe(throttle(() => interval(2000)));
  }

  fakeDataDispensaryIdPost(dispensaryId: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  featuresAnonGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  featuresIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  fincenReportsBankIdDispensaryIdGet(
    bankId: string,
    dispensaryId: string,
    extraHttpRequestParams?: any
  ): Observable<{}> {
    return of(this.fincenService.getReportByBankId(bankId, dispensaryId)).pipe(throttle(() => interval(3000)));
  }

  fincenReportsBankIdGet(bankId: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  fincenReportsBankIdPut(bankId: string, data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.fincenService.updateReport(data)).pipe(throttle(() => interval(2000)));
  }

  fincenReportsPost(data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.fincenService.createReport(data)).pipe(throttle(() => interval(2000)));
  }

  fincenReportsXmlPost(body: XmlExport, extraHttpRequestParams?: any): Observable<{}> {
    const mockResponse = {
      fileName: 'CTRXST.2019041518756754.AC0410Bank.xml',
      // tslint:disable-next-line:max-line-length
      fileData:
        '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',
    };
    return of(mockResponse).pipe(throttle(() => interval(3000)));
  }

  identitiesGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  notificationsIdDateSinceGet(dateSince: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  notificationsIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.notificationService.getNotificationsByUserId(id)).pipe(throttle(() => interval(2000)));
  }

  notificationsIdPut(id: string, data: any, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.notificationService.clearNotification(id)).pipe(throttle(() => interval(2000)));
  }

  quicksightDashboardGet(dashboard: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  resendConfirmationCodeGet(userName: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  resetDemoFlowTypeIdGet(type: string, id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  rootGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  salesFileHashHashGet(hash: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.salesFileService.checkSalesFileHash(hash)).pipe(throttle(() => interval(10000)));
  }

  salesFileProgressHashGet(hash: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  snsTopicsNameSubscriptionsPublishPost(body: string, name: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  tasksGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  tasksIdDelete(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  tasksIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  tasksIdPut(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  tasksPost(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  usersGet(extraHttpRequestParams?: any): Observable<{}> {
    return of(Object.values(this.userService.users)).pipe(throttle(() => interval(3000)));
  }

  usersIdDelete(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  usersIdGet(id: string, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.userService.getUserById(id)).pipe(throttle(() => interval(2000)));
  }

  usersIdPut(id: string, data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.userService.putUserById(data)).pipe(throttle(() => interval(3000)));
  }

  usersPost(data, extraHttpRequestParams?: any): Observable<{}> {
    return of(this.userService.createUser(data)).pipe(throttle(() => interval(3000)));
  }

  verifyUserPost(body: any, extraHttpRequestParams?: any): Observable<{}> {
    return new Observable(s => {
      s.next({});
      s.complete();
    });
  }

  workflowsTestDelete(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  workflowsTestGet(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  workflowsTestPost(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }

  workflowsTestPut(extraHttpRequestParams?: any): Observable<{}> {
    return;
  }
}
